<template>
  <div>
    <div class="condition">
      <div class="search_wrap">
        <!-- 条件筛选 -->
        <el-form ref="conditionForm" :model="conditionForm" :inline="true" class="form-inline">
          <el-form-item label="变动类型">
            <el-select v-model="conditionForm.type" placeholder="请选择变动类型" size="small" class="w130">
              <el-option label="全部" :value="0"></el-option>
              <el-option v-for="itemType in typeList" :label="itemType.name" :key="itemType.id" :value="itemType.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动名称">
            <el-input v-model="conditionForm.activity_name" placeholder="请输入活动名称" size="small"></el-input>
          </el-form-item>
          <!-- 新增套餐 接口未修改 -->
          <!-- <el-form-item label="套餐"  >
						<el-select class="mr10 w130 taocan" v-model="conditionForm.sku_id" size="small" placeholder="请选择核套餐" style="width:100%">
              <el-option label="全部"  :value="0"></el-option>
							<el-option :label="item.sku_title| ellipsis" :value="item.sku_id" v-for="(item,index) in skuList" :key="index"></el-option>
				    </el-select>              
					</el-form-item> -->
          <el-form-item label="用户昵称">
            <el-input v-model="conditionForm.buy_name" placeholder="请输入购买人昵称" size="small"></el-input>
          </el-form-item>
          <el-form-item label="变动时间">
            <el-date-picker
              v-model="timeData"
              size="small"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="changeTime"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="searchData">开始检索</el-button>
            <el-button size="small" @click="onReset">重置检索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table_wrap">
      <el-table
        :data="capitalFlowData"
        style="width: 100%" 
        :default-sort = "{prop: 'create_time', order: 'descending'}">
        <el-table-column
          label="用户昵称"
          sortable
          align="center"
          width="160px"
          >
          <div slot-scope="scope" >
            <img :src="scope.row.buy_avatar" alt width="60px" height="60px" v-if="scope.row.buy_avatar"/>
            <img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
            <p >{{scope.row.buy_name}}</p>
          </div>
        </el-table-column>
      
        <el-table-column
          prop="type_text"
          label="变动类型"
          sortable
          align="center"

          >
        </el-table-column>
        <el-table-column
          prop="money"
          label="变动金额"
          sortable
          align="center"

          >
          <div slot-scope="scope">
            <!-- <p class="colorRed" v-if="(scope.row.type == 4 ||scope.row.type == 3 || scope.row.type == 5 ) ">-{{scope.row.money}}</p>
            <p class="colorGreen" v-else>+{{scope.row.money}}</p> -->
            <p :class="scope.row.color_text">{{scope.row.money_text}} </p>
          </div>
        </el-table-column>
        <el-table-column
          prop="balance"
          label="账户余额"
          sortable
          align="center"

          >
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="变动时间"
          align="center"
          >
          <div slot-scope="scope" >
            <span>{{scope.row.create_time.split(" ")[0]}}</span>
            <br>
            <span>{{scope.row.create_time.split(" ")[1]}}</span>
          </div>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="事件概况"
          width="400px"
          >
          <div slot-scope="scope" >
            <span>{{scope.row.remark.split("，并扣除")[0]}}</span>
            <br>
            <span style="color:red">{{scope.row.remark.split("，并扣除")[1]}}</span>
          </div>
        </el-table-column>
      </el-table>
      <div class="tcenter" style="margin-top: 10px">
        <span class="rel iblock mr10 pd10 gray666" style="top: 4px; font-size: 14px;">共计{{sum}}元</span>
        <el-pagination
          class="iblock"
          background
          layout="total,prev, pager, next"
          :current-page ='pages.current_page'
          :page-size='pages.page_size' 
          :pager-count='pages.page_count' 
          :page-count="pages.total_pages"
          :total="pages.total"
          @current-change= "currentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api.js";
export default {
  name:'capitalFlow',
  filters: {//限制文本显示字数,超出部分用...代替
			ellipsis (value) {
					if (!value) return ''
					if (value.length > 10) {
						return value.slice(0,10) + '...'
					}
					return value
				}
		},
  data() {
    return {
      typeList:[],
      timeData:'',
      conditionForm:{
        start_time:'',
        end_time:'',
        type:0,
        activity_name:'',
        page:1
      },
      capitalFlowData: [{
        money: '',
        balance: '',
        remark: '',
        create_time:'',
        buy_name:'',
        type_text:'',
        type:0
      }],
      pages:{
        page_size:1,//每页数量
        current_page: 1,//当前页
        page_count: 11,//页码按钮的数量，当总页数超过该值时会折叠，只能设5-21的奇数
        total_pages: 1,//总页数
        total:0
      },
      sum: 0
    }
  },
  mounted() {
    this.getCapitalFlowData();
  },
  methods: {
    //获取流水数据
    getCapitalFlowData(){
      this.axios.post(api.capitalFlow,this.conditionForm)
        .then(res =>{
          if(res.data.code == 0){
            this.sum = res.data.result.sum
            this.typeList = res.data.result.type_list
            this.capitalFlowData = res.data.result.list
            this.pages.page_size = res.data.page.page_size//每页显示条数
            this.pages.total_pages = res.data.page.total_pages//总页数
            this.pages.current_page = res.data.page.current_page//当前页
            this.pages.total = res.data.page.total_rows//总条数
          }
        }).catch(() => {})
    },
    //选择筛选时间
    changeTime(timeValue){
      if(timeValue){
        this.conditionForm.start_time = timeValue[0];
        this.conditionForm.end_time = timeValue[1];
      }else{
        this.conditionForm.start_time = '';
        this.conditionForm.end_time = '';
      }
    },
    //检索
    searchData(){
      this.conditionForm.page = 1;
      this.getCapitalFlowData();
    },
     // 重置检索
    onReset() {
      this.conditionForm.start_time = '';
      this.conditionForm.end_time = '';
      this.timeData=''
      this.conditionForm.type = 0;
      this.conditionForm.page = 1;
      this.getCapitalFlowData();
    },
    // 分页
    currentChange(page) {
      this.conditionForm.page = page;
      this.getCapitalFlowData();
    },
  }
}
</script>